import Seo from "@/components/site/Seo";
import { Link } from "react-router-dom";
import Reveal from "@/components/site/Reveal";

const events = [
  { month: "FEB 2026", type: "Leader Session", title: "Identity systems that survive scale — Amara Okafor", where: "Virtual", tone: "border-white/10" },
  { month: "APR 2026", type: "Masterclass", title: "Brand building at scale — Full-day deep dive", where: "Virtual", tone: "border-white/10" },
  { month: "MAY 2026", type: "Leader Session", title: "The order stories are told in — Rafael Ortiz", where: "Virtual", tone: "border-white/10" },
  { month: "JUL 2026", type: "Leader Session", title: "Voice, verbal identity, defensible tone — Isabelle Marchetti", where: "Virtual", tone: "border-white/10" },
  { month: "SEP 2026", type: "Masterclass", title: "Conversion-driven design — Full-day deep dive", where: "Virtual", tone: "border-white/10" },
  { month: "NOV 2026", type: "Annual Summit", title: "Two closed-door days · Keynotes, showcases, office hours", where: "Venue TBA", tone: "border-lime" },
];

const pillClass = (type) => {
  if (type === "Annual Summit") return "bg-cream-panel";
  if (type === "Masterclass") return "bg-white/[0.08] ink border border-white/15";
  return "bg-transparent ink-muted border border-white/15";
};

export default function Events() {
  return (
    <div data-testid="events-page">
      <Seo title="Events and Cohort 2026 | Midcreatives" description="Design leader sessions, flagship masterclasses, and the annual member summit in Dubai — the Midcreatives 2026 calendar." path="/events" />
      {/* Hero */}
      <section className="max-w-screen-2xl mx-auto px-6 md:px-10 lg:px-14 pt-10 md:pt-16 pb-16 md:pb-24 relative">
        <div className="glow-blue" />
        <p className="font-mono-mc mb-6 relative">Events · Cohort 2026 calendar</p>
        <h1 className="font-display-tight text-5xl sm:text-7xl lg:text-[112px] ink leading-[0.92] max-w-6xl relative">
          Six sessions. Two masterclasses. <span className="ink-muted">One annual summit.</span>
        </h1>
        <p className="ink-muted mt-8 max-w-3xl leading-relaxed text-lg relative">
          Sessions and masterclasses run virtual — cameras on, working alongside the leader. The
          annual summit is in-person, members only, closed-door. Location is announced per cohort.
        </p>
      </section>

      {/* Calendar */}
      <section className="max-w-screen-2xl mx-auto px-6 md:px-10 lg:px-14 pb-16 md:pb-24">
        <div className="card-white rounded-3xl overflow-hidden">
          {events.map((e, i) => (
            <Reveal key={i} delay={i * 0.04}>
              <div className="grid grid-cols-12 gap-4 border-b border-white/10 last:border-b-0 py-6 md:py-8 px-6 md:px-10 items-center hover:bg-white/[0.02] transition-colors">
                <div className="col-span-4 md:col-span-2">
                  <p className="font-mono-mc ink">{e.month}</p>
                </div>
                <div className="col-span-4 md:col-span-2">
                  <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${pillClass(e.type)}`}>
                    {e.type}
                  </span>
                </div>
                <div className="col-span-4 md:col-span-2">
                  <p className="font-mono-mc">{e.where}</p>
                </div>
                <div className="col-span-12 md:col-span-6">
                  <h4 className="font-display-tight text-2xl md:text-3xl ink leading-tight">{e.title}</h4>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Summit */}
      <section className="max-w-screen-2xl mx-auto px-6 md:px-10 lg:px-14 pb-24 md:pb-32">
        <div className="rounded-[32px] border border-white/10 bg-[color:var(--surface)] p-8 md:p-16 grid grid-cols-1 md:grid-cols-12 gap-10 items-center relative overflow-hidden">
          <div className="glow-lime" />
          <div className="md:col-span-7 relative">
            <p className="font-mono-mc mb-4">Annual Summit · November 2026</p>
            <h2 className="font-display-tight text-4xl md:text-6xl ink leading-[1.0]">
              Two days. One room. <span className="text-lime">Every seat earned.</span>
            </h2>
            <p className="ink-muted mt-6 leading-relaxed max-w-xl">
              Closed-door sessions. Leader keynotes. Brand showcases from members. One-on-one
              office hours with visiting design leaders. No press, no cameras, no outsiders. The
              venue is announced ahead of the cohort.
            </p>
            <Link to="/apply" data-testid="events-apply-cta" className="btn-dark mt-8">
              Get Membership <span className="arrow-slide">→</span>
            </Link>
          </div>
          <div className="md:col-span-5 relative">
            <div className="rounded-3xl overflow-hidden aspect-[5/4] border border-white/10">
              <img
                src="https://images.unsplash.com/photo-1511578314322-379afb476865?w=1200"
                alt="Summit"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
